import React from "react";
import { CourseItemDashBoard } from "../../../../../service/service";
import style from "./DataList.module.scss";
import { Col, Empty, Row } from "antd";
import DateItem from "../DateItem";

interface DataListProps {
    title: string;
    data: CourseItemDashBoard[];
}

export function DataList({ title, data }: DataListProps) {
    return (
        <div className={style.root}>
            <h1 className={style.title}>{title}</h1>

            <Row>
                {data.map((item, index) => (
                    <Col
                        span={4}
                        key={`${item.course}-${item.seq}-${item.teacherId}-${index}`}>
                        <DateItem data={item} />
                    </Col>
                ))}

                {data.length === 0 && <Empty className={style.empty} />}
            </Row>
        </div>
    );
}
